import script from "./Modal-Nueva-Tasa-Envios.vue?vue&type=script&setup=true&lang=js"
export * from "./Modal-Nueva-Tasa-Envios.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__